<template lang="html">
  <div class="logo-login">
    <div class="container flex mx-auto w-full md:mt-2 md:px-4 md:py-2">
      <div class="flex justify-start w-1/2">
        <a href="/">
          <img
            v-bind:src="logo"
            v-bind:alt="alt"
            class="mb-2 w-10 md:w-16 absolute right-0 mr-8 mt-6 md:relative md:m-0"
          />
        </a>
      </div>

      <div
        v-if="user.loggedIn"
        class="flex justify-end w-1/2 mt-2 hidden md:block"
      >
        <span class="float-right">
          <router-link class="mr-6 text-sm" :to="{ name: 'home' }"
            >Dashboard</router-link
          >
          <!--<router-link class="mr-6 text-sm" :to="{ name: 'profile' }"
          >Profile</router-link
        >-->
          <a
            class="mr-6 text-sm cursor-pointer hover:text-push-blue"
            @click="logout"
            >Logout</a
          >
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import firebase from "firebase/app";
export default {
  name: "topbarminimal",
  data() {
    return {
      logo: require("@/assets/img/LogoPPmedium.png"),
      alt: "Push Poll"
    };
  },
  computed: {
    ...mapState({
      user: "user"
    })
  },
  methods: {
    logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$cookies.remove("user_session");
          this.$router.replace({
            name: "login"
          });
        });
    }
  }
};
</script>
